import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/layout';
import { SideNavigation } from '../components/navigation';
import { SessionExpirationHandler, DevelopmentModeBanner } from '../components/auth';
import { SkipToMain } from '../components/layout/SkipToMain';
import { useAuth } from '../contexts';

export function RootLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [navigationOpen, setNavigationOpen] = useState(true);
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const handleNavigationFollow = (event: any) => {
    event.preventDefault();
    navigate(event.detail.href);
  };

  // Format user data for AppLayout
  const userData = user
    ? {
        name: user.name || user.username,
        email: user.email || '',
      }
    : {
        name: 'Guest',
        email: '',
      };

  return (
    <>
      <SkipToMain mainContentId="main-content" />
      <SessionExpirationHandler />
      <AppLayout
        navigation={
          <SideNavigation
            activeHref={location.pathname}
            onFollow={handleNavigationFollow}
          />
        }
        user={userData}
        onLogout={handleLogout}
        navigationOpen={navigationOpen}
        onNavigationChange={setNavigationOpen}
        activeHref={location.pathname}
        onNavigationFollow={handleNavigationFollow}
      >
        <main id="main-content" role="main" tabIndex={-1} aria-label="Main content">
          <DevelopmentModeBanner />
          <Outlet />
        </main>
      </AppLayout>
    </>
  );
}
